import { Card, CardHeader, CardContent } from '@/components/ui/card'

export function WorldCardSkeleton() {
  return (
    <Card>
      <CardHeader>
        <div className="flex items-start justify-between">
          <div className="bg-muted h-5 w-32 animate-pulse rounded" />
          <div className="bg-muted h-5 w-16 animate-pulse rounded-full" />
        </div>
        <div className="bg-muted mt-2 h-4 w-40 animate-pulse rounded" />
      </CardHeader>
      <CardContent>
        <div className="flex gap-6">
          <div className="bg-muted h-4 w-16 animate-pulse rounded" />
          <div className="bg-muted h-4 w-20 animate-pulse rounded" />
        </div>
      </CardContent>
    </Card>
  )
}
